/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ScanToPayIdentifyTokenQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ScanToPayIdentifyTokenQuery = {
  readonly __typename?: 'Query';
  readonly loyaltyProfile: {
    readonly __typename: 'LoyaltyProfile';
    readonly customerId: string;
    readonly customerToken:
      | {
          readonly __typename: 'CustomerTokenError';
          readonly code: string;
          readonly errorMessage: string;
        }
      | {
          readonly __typename: 'LoyaltyAccessToken';
          readonly token: string;
          readonly expiresAt: string;
        }
      | null;
  } | null;
};

export const ScanToPayIdentifyTokenDocument = gql`
  query ScanToPayIdentifyToken {
    loyaltyProfile {
      customerId
      __typename
      customerToken(purpose: IDENTIFY) {
        ... on LoyaltyAccessToken {
          token
          expiresAt
          __typename
        }
        ... on CustomerTokenError {
          code
          errorMessage
          __typename
        }
      }
    }
  }
`;

export function useScanToPayIdentifyTokenQuery(
  options?: Omit<Urql.UseQueryArgs<ScanToPayIdentifyTokenQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ScanToPayIdentifyTokenQuery, ScanToPayIdentifyTokenQueryVariables>({
    query: ScanToPayIdentifyTokenDocument,
    ...options,
  });
}
